import posthog from "posthog-js";
import { useSubmitUtilityData } from "queries/Utility/useSubmitUtilityData";

// components
import SimpleCsvUploader from "components/molecules/SimpleCsvUploader";
import useBuildingLoadingState from "recoilStore/useBuildingLoadingState";
import { useQueryOnStatusUpdate } from "./BuildingEnergy.hooks";

interface UtilityCsvUploaderProps {
    buildingModelUid: string;
}

function UtilityCsvUploader({ buildingModelUid }: UtilityCsvUploaderProps) {
    const { setLoadingState } = useBuildingLoadingState(buildingModelUid);
    const { onSuccess, onError } = useQueryOnStatusUpdate(buildingModelUid);

    const { mutate: submitUtilityData } = useSubmitUtilityData(
        buildingModelUid,
        () => {
            onSuccess();
            posthog.capture("import_energy_completed");
        },
        () => {
            onError();
            posthog.capture("import_energy_failed");
        }
    );

    const convertDateFormat = (dateStr: string): string => {
        const [month, day, year] = dateStr.split("/");
        return `${year}-${month}-${day}`;
    };

    const onResults = (results: any) => {
        const utilityData = results.map((row: any) => ({
            utilityProvider: row.utility_provider,
            accountNumber: row.account_number,
            utilityType: row.utility_type,
            startDate: convertDateFormat(row.start_date),
            endDate: convertDateFormat(row.end_date),
            energyConsumption: parseFloat(row.energy_consumption),
            energyConsumptionUnit: row.energy_consumption_unit,
            utilityCost: row.utility_cost !== "" ? parseFloat(row.utility_cost) : null,
            currency: row.currency,
        }));
        setLoadingState((prev) => ({
            ...prev,
            energySidebarLoading: true,
            buildingReportsLoading: true,
        }));
        submitUtilityData(utilityData);
    };

    return <SimpleCsvUploader onResults={onResults} importIdentifier="utilities" />;
}

export default UtilityCsvUploader;
